import { ReplaceAroundStep, Mapping } from 'prosemirror-transform'
import { Transaction, EditorState } from 'prosemirror-state'
import { addInsertionMarks } from './addInsertionMarks'
import { addDeletionMarks } from './addDeletionMarks'
import { addWrappingMarks } from './addWrappingMarks'
import { Context } from './Types'

export function trackReplaceAroundStep(
  originalStep: ReplaceAroundStep,
  userId: number,
  state: EditorState,
  tr: Transaction,
  map: Mapping,
  index: number,
  context?: Context,
) {
  const step = originalStep.map(map)

  if (!step) {
    return
  }

  if (wrapping(step)) {
    tr.step(step)
    const from = step.getMap().map(step.from, -1)
    const to = step.getMap().map(step.gapFrom)
    addInsertionMarks(tr, from, to, userId, context)
  } else if (unwrapping(step)) {
    const invertStep = originalStep.invert(tr.docs[index]).map(map)
    if (!invertStep) {
      return
    }
    map.appendMap(invertStep.getMap())
    map.appendMapping(addDeletionMarks(tr, step.from, step.gapFrom, userId, context))
  } else if (replacingWrap(step)) {
    tr.step(step)
    const oldNode = (tr.docs[tr.docs.length - 1] || state.doc).nodeAt(step.from)
    if (oldNode?.type.spec.attrs?.trackedChanges) {
      addWrappingMarks(tr, step.from, oldNode, step.slice.content.firstChild, userId, context)
    }
  } else {
    tr.step(step)
    const ranges = [
      { from: step.getMap().map(step.from, -1), to: step.getMap().map(step.gapFrom) },
      { from: step.getMap().map(step.gapTo, -1), to: step.getMap().map(step.to) },
    ]
    ranges.forEach(({ from, to }) => {
      tr.doc.nodesBetween(from, to, (_, pos) => {
        if (pos < from) {
          return true
        }
        addInsertionMarks(tr, from, to, userId, context)
      })
    })
  }
}

function wrapping(step: ReplaceAroundStep) {
  return step.from === step.gapFrom && step.to === step.gapTo
}

function unwrapping(step: ReplaceAroundStep) {
  return !step.slice.size || step.slice.content.content.length === 2
}

function replacingWrap(step: ReplaceAroundStep) {
  return step.slice.size === 2 && step.gapFrom - step.from === 1 && step.to - step.gapTo === 1
}
